// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  overlay.onclick = () => overlay.remove();
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => overlay.remove();
}

let posX = 0, posY = 0;

function initKeyboardNav(image, zoomRatio) {
  function keyHandling(e) {
    const factor = 10;
    switch(e.key) {
      case "ArrowUp":
        posY-=factor;
        moveWithHover(image, { target: image, clientX: posX, clientY: posY }, zoomRatio);
        break;

      case "ArrowDown":
        posY+=factor;
        moveWithHover(image, { target: image, clientX: posX, clientY: posY }, zoomRatio);
        break;

      case "ArrowLeft":
        posX-=factor;
        moveWithHover(image, { target: image, clientX: posX, clientY: posY }, zoomRatio);
        break;

      case "ArrowRight":
        posX+=factor;
        moveWithHover(image, { target: image, clientX: posX, clientY: posY }, zoomRatio);
        break;

      case "Escape":
        overlay.remove();
        document.removeEventListener("keyup", keyHandling);
        break;

      case " ":
        e.preventDefault();
        overlay.remove();
        document.removeEventListener("keyup", keyHandling);
        break;
    }
  }

  document.addEventListener("keyup", keyHandling)
}


function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    const srButton = document.querySelector(".sr-magnify-button");
    console.log("sr: ", srButton, image);
    if (srButton) {
      const rect = image.getBoundingClientRect();
      srButton.onclick = (event) => {
        magnify(image, zoomRatio);
        posX = rect.left;
        posY = rect.top;
        moveWithHover(image, { target: image, clientX: posX, clientY: posY }, zoomRatio);
        initKeyboardNav(image, zoomRatio);
      };
    };
    image.onclick = (event) => {
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
      initKeyboardNav(image, zoomRatio);
    };
  });
}

enableZoomOnHover(2);
